module.exports = __webpack_public_path__ + "static/media/background.15951642.png";